<mat-card class="mb-4">
    <mat-card-header>
        <mat-card-title>
            Firmen/Standorte
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <form [formGroup]="firmenSearchForm" class="search-form" (keydown.enter)="$event.preventDefault()" (keyup.enter)="search(0)">
            <div class="form-text ml-3">
                <p>Suchen nach</p>
            </div>
            <div class="form-firma-input">
                <mat-form-field class="input-field">
                    <input matInput formControlName="firma" placeholder="Firma (Firmen-ID, Firmenname, Crefonummer, Firmenstandorte-ID)">
                </mat-form-field>
            </div>
            <div class="form-text mx-2">
                <p>oder</p>
            </div>
            <div class="form-firmenstandort-input">
                <mat-form-field class="input-field">
                    <input matInput formControlName="firmenstandort" placeholder="Firmenstandort (Stra&szlig;e, PLZ, Ort, BeDirect-ID)">
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions class="search-buttons">
        <button class="btn btn-flat bg-gradient-secondary mr-4" *ngIf="resultDataSource" (click)="removeFilters()">
            Zur&uuml;cksetzen <i class="fas fa-times"></i>
        </button>
        <button class="btn btn-flat bg-gradient-primary pl-4 pr-4" (click)="search(0)">
            Suchen <i class="fas fa-search"></i>
        </button>
    </mat-card-actions>
</mat-card>

<mat-card *ngIf="resultDataSource">
    <mat-card-header>
        <mat-card-title>Ergebnis</mat-card-title>
        <div class="toggle-deleted-elements">
            <mat-slide-toggle color="primary" 
                [checked]="showAlsoDeletedElements"
                (change)="updateResultList()">
                Auch gel&ouml;schte Standorte anzeigen
            </mat-slide-toggle>
        </div>
    </mat-card-header>
    <mat-card-content>
        <table mat-table [dataSource]="resultDataSource" class="mat-elevation-z1">

            <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns">
                <th mat-header-cell *matHeaderCellDef> {{column.label.toUpperCase()}}
                    <button mat-icon-button color="primary" *ngIf="!column.isFiltered" matTooltip="Spalte filtern" [matMenuTriggerFor]="menu">
                        <mat-icon class="mat-icon-rtl-mirror">
                            filter_list
                        </mat-icon>
                    </button>
                    <button mat-icon-button color="primary" matTooltip="Filter entfernen" *ngIf="column.isFiltered" (click)="removeColumnFilter(column.name)">
                        <mat-icon class="mat-icon-rtl-mirror">
                            filter_list_off
                        </mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <div class="flex-container">
                            <mat-form-field class="input-field">
                                <input matInput #inputField placeholder="{{column.label}} filtern" (click)="$event.stopPropagation()" (keyup.enter)="filterField(column.name, column.type, inputField.value)">
                            </mat-form-field>
                            <button class="btn btn-xs btn-flat bg-gradient-primary ml-2 pr-2 pl-2 pt-1 pb-1" (click)="filterField(column.name, column.type, inputField.value)">
                                <i class="fas fa-filter"></i>
                            </button>
                        </div>
                    </mat-menu>
                </th>
                <td mat-cell [class.deleted-element]="element.istGeloescht == true" *matCellDef="let element">
                    {{element[column.name]}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="goToFirma(row)"></tr>
        </table>
        <div class="paginator-container">
            <mat-paginator
                (page)="getPageData($event)"
                [length]="resultListLength" 
                [pageIndex]="currentPage"
                [pageSize]="pageSize"
                [hidePageSize]="true"
                [showFirstLastButtons]="true">
            </mat-paginator>
        </div>
    </mat-card-content>
</mat-card>
    